// eslint-disable-next-line import/prefer-default-export
export const CATEGORY_ID = {
  mycart: 'mycart',
  myfavorites: 'myfavorites',
  sponsored: 'sponsored',
};

export const STATIC_CATEGORY_IDS = [
  CATEGORY_ID.mycart,
  CATEGORY_ID.myfavorites,
  CATEGORY_ID.sponsored,
];

export const isStaticCategory = (selectedCategoryId) =>
  STATIC_CATEGORY_IDS.includes(selectedCategoryId);

export const ALL_CATEGORY = [
  {
    id: null,
    name: 'All',
    children: [],
  },
];

// these categories are always displayed
export const STATIC_CATEGORIES = [
  ...ALL_CATEGORY,
  {
    id: 'mycart',
    name: 'My Cart',
    children: [],
  },
  {
    id: 'myfavorites',
    name: 'My Favorites',
    children: [],
  },
];
